// The empty-value mark (`—`) a figure shows when it has no value, hidden from assistive tech, which
// hears `spoken` instead. First the basket's cells' (Pricing migration 19, ADO-2250); shared since
// Story 11.10 (ADO-1961) so the product card and the PDP mark an unavailable margin the same way.
import styles from './EmptyValue.module.css';

/** The mark itself: an em dash, as the designs draw it. */
export const EMPTY_VALUE_GLYPH = '—';

export function EmptyValue({
  spoken,
  className,
}: {
  /** What a screen reader hears in place of the mark ("not available"). */
  readonly spoken: string;
  /** The host's value style (the cell's, the meta line's). */
  readonly className?: string;
}) {
  return (
    <span className={className} data-part="value">
      <span aria-hidden="true">{EMPTY_VALUE_GLYPH}</span>
      <span className={styles.visuallyHidden}>{spoken}</span>
    </span>
  );
}
